var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "market-list-form" },
    [
      _c(
        "el-radio-group",
        {
          staticStyle: { "margin-bottom": "30px" },
          attrs: { size: "small" },
          model: {
            value: _vm.activeSetting,
            callback: function ($$v) {
              _vm.activeSetting = $$v
            },
            expression: "activeSetting",
          },
        },
        [
          _c("el-radio-button", { attrs: { label: 1 } }, [_vm._v("内 容")]),
          _vm._v(" "),
          _c("el-radio-button", { attrs: { label: 2 } }, [_vm._v("样 式")]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.activeSetting == 1,
              expression: "activeSetting==1",
            },
          ],
          attrs: { model: _vm.itemInfo, "label-width": "100px" },
        },
        [
          _c("el-alert", {
            staticStyle: { "margin-bottom": "10px" },
            attrs: {
              closable: false,
              title: "建议图片宽度90 * 90px，大小需小于等于300KB",
              type: "warning",
              "show-icon": "",
            },
          }),
          _vm._v(" "),
          _c(
            "draggable",
            {
              on: { end: _vm.onEnd },
              model: {
                value: _vm.itemInfo.menus,
                callback: function ($$v) {
                  _vm.$set(_vm.itemInfo, "menus", $$v)
                },
                expression: "itemInfo.menus",
              },
            },
            _vm._l(_vm.itemInfo.menus, function (item, index) {
              return _c(
                "el-card",
                { key: index, staticStyle: { "margin-bottom": "15px" } },
                [
                  _c("div", { staticClass: "market-item flex" }, [
                    _vm.userType === 1
                      ? _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "align-items": "center",
                              width: "100px",
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "upLoadPicBox",
                                on: {
                                  click: function ($event) {
                                    return _vm.modalPicTap("1", "pic", index)
                                  },
                                },
                              },
                              [
                                item.pic
                                  ? _c("div", { staticClass: "pictrue" }, [
                                      _c("img", { attrs: { src: item.pic } }),
                                    ])
                                  : _c("div", { staticClass: "upLoad" }, [
                                      _c("i", {
                                        staticClass:
                                          "el-icon-camera cameraIconfont",
                                      }),
                                    ]),
                              ]
                            ),
                            _vm._v(" "),
                            item.pic
                              ? _c("i", {
                                  staticClass: "el-icon-delete",
                                  staticStyle: {
                                    color: "red",
                                    "font-size": "16px",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.removeImg("pic", index)
                                    },
                                  },
                                })
                              : _vm._e(),
                          ]
                        )
                      : _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "align-items": "center",
                            },
                          },
                          [
                            _c(
                              "el-upload",
                              {
                                staticClass: "avatar-uploader-small",
                                attrs: {
                                  action: "",
                                  "show-file-list": false,
                                  "http-request": function (options) {
                                    return _vm.handleLocalUpload(
                                      options,
                                      "pic",
                                      index
                                    )
                                  },
                                  "before-upload": _vm.beforeNavUpload,
                                  accept: "image/*",
                                },
                              },
                              [
                                item.pic
                                  ? _c("img", {
                                      staticClass: "avatar-small",
                                      attrs: { src: item.pic },
                                    })
                                  : _c("i", {
                                      staticClass:
                                        "el-icon-plus avatar-uploader-icon-small",
                                    }),
                              ]
                            ),
                            _vm._v(" "),
                            item.pic
                              ? _c("i", {
                                  staticClass: "el-icon-delete",
                                  staticStyle: {
                                    color: "red",
                                    "font-size": "16px",
                                    "margin-left": "10px",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.removeImg("pic", index)
                                    },
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticStyle: { width: "calc(100% - 100px)" } },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "flex",
                            staticStyle: { "margin-bottom": "15px" },
                          },
                          [
                            _c(
                              "div",
                              { staticStyle: { "margin-right": "10px" } },
                              [_vm._v("标题：")]
                            ),
                            _vm._v(" "),
                            _c("el-input", {
                              staticStyle: { width: "240px" },
                              attrs: { placeholder: "请输入", min: 0 },
                              on: { blur: _vm.updateItem },
                              model: {
                                value: item.name,
                                callback: function ($$v) {
                                  _vm.$set(item, "name", $$v)
                                },
                                expression: "item.name",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "flex",
                            staticStyle: { "align-items": "baseline" },
                          },
                          [
                            _c(
                              "div",
                              { staticStyle: { "margin-right": "10px" } },
                              [_vm._v("链接：")]
                            ),
                            _vm._v(" "),
                            _c("JumpNative", {
                              staticStyle: { width: "240px" },
                              model: {
                                value: item.url,
                                callback: function ($$v) {
                                  _vm.$set(item, "url", $$v)
                                },
                                expression: "item.url",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "flex" }, [
                      _c("div", { staticClass: "drag-icon el-icon-rank" }),
                      _vm._v(" "),
                      _c("i", {
                        staticClass: "el-icon-remove",
                        staticStyle: {
                          color: "red",
                          "font-size": "18px",
                          "margin-left": "10px",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.removeNavItem(index)
                          },
                        },
                      }),
                    ]),
                  ]),
                ]
              )
            }),
            1
          ),
          _vm._v(" "),
          _c("el-divider"),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "add-btn",
              staticStyle: { width: "100%" },
              attrs: { type: "primary" },
              on: { click: _vm.addMenusContent },
            },
            [_vm._v("添加内容")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.activeSetting == 2,
              expression: "activeSetting==2",
            },
          ],
          attrs: { model: _vm.itemInfo, "label-width": "100px" },
        },
        [
          _c("el-form-item", { attrs: { label: "背景图片：" } }, [
            _vm.userType === 1
              ? _c(
                  "div",
                  { staticStyle: { display: "flex", "align-items": "center" } },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "upLoadPicBox",
                        on: {
                          click: function ($event) {
                            return _vm.modalPicTap("1", "bgImg")
                          },
                        },
                      },
                      [
                        _vm.itemInfo.bgImg
                          ? _c("div", { staticClass: "pictrue" }, [
                              _c("img", { attrs: { src: _vm.itemInfo.bgImg } }),
                            ])
                          : _c("div", { staticClass: "upLoad" }, [
                              _c("i", {
                                staticClass: "el-icon-camera cameraIconfont",
                              }),
                            ]),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.itemInfo.bgImg
                      ? _c("i", {
                          staticClass: "el-icon-delete",
                          staticStyle: { color: "red", "font-size": "16px" },
                          on: {
                            click: function ($event) {
                              return _vm.removeImg("image", -1)
                            },
                          },
                        })
                      : _vm._e(),
                  ]
                )
              : _c(
                  "div",
                  { staticStyle: { display: "flex", "align-items": "center" } },
                  [
                    _c(
                      "el-upload",
                      {
                        staticClass: "avatar-uploader",
                        attrs: {
                          action: "",
                          "show-file-list": false,
                          "http-request": function (options) {
                            return _vm.handleLocalUpload(options, "bgImg")
                          },
                          "before-upload": _vm.beforeUpload,
                          accept: "image/*",
                        },
                      },
                      [
                        _vm.itemInfo.bgImg
                          ? _c("img", {
                              staticClass: "avatar",
                              attrs: { src: _vm.itemInfo.bgImg },
                            })
                          : _c("i", {
                              staticClass: "el-icon-plus avatar-uploader-icon",
                            }),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.itemInfo.bgImg
                      ? _c("i", {
                          staticClass: "el-icon-delete",
                          staticStyle: {
                            color: "red",
                            "font-size": "20px",
                            "margin-left": "10px",
                            cursor: "pointer",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.removeImg("image", -1)
                            },
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "upload-tip",
                        staticStyle: { "margin-left": "10px" },
                      },
                      [_vm._v("支持jpg、png格式，不超过2MB")]
                    ),
                  ],
                  1
                ),
          ]),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "背景色：" } },
            [
              _c("el-color-picker", {
                attrs: { "show-alpha": "" },
                on: { change: _vm.updateItem },
                model: {
                  value: _vm.itemInfo.bgColor,
                  callback: function ($$v) {
                    _vm.$set(_vm.itemInfo, "bgColor", $$v)
                  },
                  expression: "itemInfo.bgColor",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-form-item", { attrs: { label: "导航宽高：" } }, [
            _c(
              "div",
              { staticClass: "flex", staticStyle: { "margin-bottom": "5px" } },
              [
                _c("div", { staticStyle: { "margin-right": "10px" } }, [
                  _vm._v("宽度："),
                ]),
                _vm._v(" "),
                _c("el-input-number", {
                  attrs: { min: 0 },
                  on: { change: _vm.updateItem },
                  model: {
                    value: _vm.itemInfo.navWidth,
                    callback: function ($$v) {
                      _vm.$set(_vm.itemInfo, "navWidth", $$v)
                    },
                    expression: "itemInfo.navWidth",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex", staticStyle: { "margin-bottom": "5px" } },
              [
                _c("div", { staticStyle: { "margin-right": "10px" } }, [
                  _vm._v("高度："),
                ]),
                _vm._v(" "),
                _c("el-input-number", {
                  attrs: { min: 0 },
                  on: { change: _vm.updateItem },
                  model: {
                    value: _vm.itemInfo.navHeight,
                    callback: function ($$v) {
                      _vm.$set(_vm.itemInfo, "navHeight", $$v)
                    },
                    expression: "itemInfo.navHeight",
                  },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "平均分布：" } },
            [
              _c("el-switch", {
                attrs: {
                  "active-value": 1,
                  "active-text": "是",
                  "inactive-text": "否",
                  "inactive-value": 0,
                },
                on: { change: _vm.updateItem },
                model: {
                  value: _vm.itemInfo.showBtw,
                  callback: function ($$v) {
                    _vm.$set(_vm.itemInfo, "showBtw", $$v)
                  },
                  expression: "itemInfo.showBtw",
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticStyle: { color: "#999", "line-height": "18px" } },
                [
                  _vm._v(
                    "仅导航不满一屏时生效。开启平均分布则按一屏平均分布，将不按照内部间距排列！"
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-form-item", { attrs: { label: "内间距：" } }, [
            _c(
              "div",
              { staticClass: "flex", staticStyle: { "margin-bottom": "5px" } },
              [
                _c("div", { staticStyle: { "margin-right": "10px" } }, [
                  _vm._v("上："),
                ]),
                _vm._v(" "),
                _c("el-input-number", {
                  attrs: { min: 0 },
                  on: { change: _vm.updateItem },
                  model: {
                    value: _vm.itemInfo.navPadding.pt,
                    callback: function ($$v) {
                      _vm.$set(_vm.itemInfo.navPadding, "pt", $$v)
                    },
                    expression: "itemInfo.navPadding.pt",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex", staticStyle: { "margin-bottom": "5px" } },
              [
                _c("div", { staticStyle: { "margin-right": "10px" } }, [
                  _vm._v("下："),
                ]),
                _vm._v(" "),
                _c("el-input-number", {
                  attrs: { min: 0 },
                  on: { change: _vm.updateItem },
                  model: {
                    value: _vm.itemInfo.navPadding.pb,
                    callback: function ($$v) {
                      _vm.$set(_vm.itemInfo.navPadding, "pb", $$v)
                    },
                    expression: "itemInfo.navPadding.pb",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex", staticStyle: { "margin-bottom": "5px" } },
              [
                _c("div", { staticStyle: { "margin-right": "10px" } }, [
                  _vm._v("左："),
                ]),
                _vm._v(" "),
                _c("el-input-number", {
                  attrs: { min: 0 },
                  on: { change: _vm.updateItem },
                  model: {
                    value: _vm.itemInfo.navPadding.pl,
                    callback: function ($$v) {
                      _vm.$set(_vm.itemInfo.navPadding, "pl", $$v)
                    },
                    expression: "itemInfo.navPadding.pl",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex", staticStyle: { "margin-bottom": "5px" } },
              [
                _c("div", { staticStyle: { "margin-right": "10px" } }, [
                  _vm._v("右："),
                ]),
                _vm._v(" "),
                _c("el-input-number", {
                  attrs: { min: 0 },
                  on: { change: _vm.updateItem },
                  model: {
                    value: _vm.itemInfo.navPadding.pr,
                    callback: function ($$v) {
                      _vm.$set(_vm.itemInfo.navPadding, "pr", $$v)
                    },
                    expression: "itemInfo.navPadding.pr",
                  },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "内部间距：" } },
            [
              _c("el-input-number", {
                attrs: { min: 0 },
                on: { change: _vm.updateItem },
                model: {
                  value: _vm.itemInfo.midPadding,
                  callback: function ($$v) {
                    _vm.$set(_vm.itemInfo, "midPadding", $$v)
                  },
                  expression: "itemInfo.midPadding",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-form-item", { attrs: { label: "外间距：" } }, [
            _c(
              "div",
              { staticClass: "flex", staticStyle: { "margin-bottom": "5px" } },
              [
                _c("div", { staticStyle: { "margin-right": "10px" } }, [
                  _vm._v("上："),
                ]),
                _vm._v(" "),
                _c("el-input-number", {
                  attrs: { min: 0 },
                  on: { change: _vm.updateItem },
                  model: {
                    value: _vm.itemInfo.formMargin.mt,
                    callback: function ($$v) {
                      _vm.$set(_vm.itemInfo.formMargin, "mt", $$v)
                    },
                    expression: "itemInfo.formMargin.mt",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex", staticStyle: { "margin-bottom": "5px" } },
              [
                _c("div", { staticStyle: { "margin-right": "10px" } }, [
                  _vm._v("下："),
                ]),
                _vm._v(" "),
                _c("el-input-number", {
                  attrs: { min: 0 },
                  on: { change: _vm.updateItem },
                  model: {
                    value: _vm.itemInfo.formMargin.mb,
                    callback: function ($$v) {
                      _vm.$set(_vm.itemInfo.formMargin, "mb", $$v)
                    },
                    expression: "itemInfo.formMargin.mb",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex", staticStyle: { "margin-bottom": "5px" } },
              [
                _c("div", { staticStyle: { "margin-right": "10px" } }, [
                  _vm._v("左："),
                ]),
                _vm._v(" "),
                _c("el-input-number", {
                  attrs: { min: 0 },
                  on: { change: _vm.updateItem },
                  model: {
                    value: _vm.itemInfo.formMargin.ml,
                    callback: function ($$v) {
                      _vm.$set(_vm.itemInfo.formMargin, "ml", $$v)
                    },
                    expression: "itemInfo.formMargin.ml",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex", staticStyle: { "margin-bottom": "5px" } },
              [
                _c("div", { staticStyle: { "margin-right": "10px" } }, [
                  _vm._v("右："),
                ]),
                _vm._v(" "),
                _c("el-input-number", {
                  attrs: { min: 0 },
                  on: { change: _vm.updateItem },
                  model: {
                    value: _vm.itemInfo.formMargin.mr,
                    callback: function ($$v) {
                      _vm.$set(_vm.itemInfo.formMargin, "mr", $$v)
                    },
                    expression: "itemInfo.formMargin.mr",
                  },
                }),
              ],
              1
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }